"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "payments_cont" };
const _hoisted_2 = { class: "payments_title" };
const _hoisted_3 = {
    key: 0,
    class: "tm-warning"
};
const _hoisted_4 = { class: "label label-error" };
const _hoisted_5 = {
    key: 1,
    class: "payments_save"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_payment_unit_component = (0, vue_1.resolveComponent)("payment-unit-component");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("section", null, [
            (0, vue_1.createElementVNode)("h3", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.SPENDABLE_RESOURCES, (unit) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, [
                    (_ctx.canUse(unit) === true)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_payment_unit_component, {
                            modelValue: _ctx.payment[unit],
                            "onUpdate:modelValue": ($event) => ((_ctx.payment[unit]) = $event),
                            modelModifiers: { number: true },
                            key: unit,
                            unit: unit,
                            description: _ctx.descriptions[unit],
                            onPlus: ($event) => (_ctx.addValue(unit)),
                            onMinus: ($event) => (_ctx.reduceValue(unit)),
                            onMax: ($event) => (_ctx.onMaxClicked(unit))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "unit", "description", "onPlus", "onMinus", "onMax"]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.showReserveWarning(unit))
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "card-warning",
                            key: unit + '-reserve'
                        }, [...(_cache[0] || (_cache[0] = [
                                (0, vue_1.createTextVNode)(" (Some ${0} are reserved for the action and unavailable here.) ", -1)
                            ]))])), [
                            [_directive_i18n, _ctx.$t(unit)]
                        ])
                        : (0, vue_1.createCommentVNode)("", true)
                ], 64));
            }), 256)),
            (_ctx.hasWarning())
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                    (0, vue_1.createElementVNode)("label", _hoisted_4, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.warning)), 1)
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.showsave === true)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                    (0, vue_1.createVNode)(_component_AppButton, {
                        size: "big",
                        onClick: _ctx.saveData,
                        title: _ctx.$t(_ctx.playerinput.buttonLabel),
                        "data-test": "save"
                    }, null, 8, ["onClick", "title"])
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ])), [
            [_directive_trim_whitespace]
        ])
    ]));
}
